import { currencyCookieName, currencyOptions } from "../constants";
import type { CurrencyPreference } from "../types";
import { getCookie } from "./storage";

export function findCurrencyOption(preference: CurrencyPreference) {
  return (
    currencyOptions.find(
      (option) => option.locale === preference.locale && option.currency === preference.currency
    ) ?? {
      ...preference,
      flag: "🌐",
      label: `${preference.locale} - ${preference.currency}`,
      shortLabel: preference.currency
    }
  );
}

export function loadCurrencyPreference(): CurrencyPreference {
  const savedPreference = getCookie(currencyCookieName);

  if (savedPreference) {
    try {
      return JSON.parse(savedPreference) as CurrencyPreference;
    } catch {
      document.cookie = `${currencyCookieName}=; max-age=0; path=/; SameSite=Lax`;
    }
  }

  const locale = navigator.language || "en-GB";

  return {
    currency: guessCurrencyFromLocale(locale),
    locale
  };
}

function guessCurrencyFromLocale(locale: string) {
  const region = locale.split("-")[1]?.toUpperCase();

  switch (region) {
    case "US":
      return "USD";
    case "IE":
    case "FR":
    case "DE":
    case "ES":
    case "IT":
      return "EUR";
    case "AU":
      return "AUD";
    case "CA":
      return "CAD";
    default:
      return "GBP";
  }
}
